export const sectionTitles = {
    featuredArticleBtnTxt: 'Read More',
    categoryGridTitle: 'Explore by topic',
    articleGridTitle: 'New From Quicken Loans'
}